import { type ApplicationConfig } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CacheInterceptor } from './shared/cache.interceptor';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { authtokenheaderInterceptor } from './shared/authtokenheader.interceptor';
import { provideNgIdle } from '@ng-idle/core';
import { headersInterceptor } from './shared/interceptors/headers.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideClientHydration(),
    provideHttpClient(
      withFetch(),
      withInterceptors([CacheInterceptor, headersInterceptor, authtokenheaderInterceptor]),
    ),
    provideAnimations(),
    provideNativeDateAdapter(),
    provideEnvironmentNgxMask(),
    provideNgIdle(),
  ],
};
